import * as type from "../../types";

const initialState = {
  loading: false,
  subtraction: [],
  error: null,
};

export const viewSubTractionReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.SUBTRANCTION_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.SUBTRANCTION_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        subtraction: action.subtraction,
      };
    case type.SUBTRANCTION_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
